import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { borderRadius } from 'ui/theme';

const StyledThumbnailSkeleton = styled(Skeleton)`
  border-radius: ${borderRadius.lg};
`;

export const PreviewThumbnailLoading = () => (
  <StyledThumbnailSkeleton width={48} height={36} isRound />
);
